<template>
  <div class="select-company">
    <div class="tips">
      <span>{{ topTips }}</span>
    </div>

    <div class="bint-wechat" v-if="isBindWechat" @click="onUnbind">
      <span class="binded-mobile">{{ userMobile }}</span>
      <span class="bind-tips">已绑定微信</span>
    </div>

    <div class="company-list company-list-margin">
      <div class="item" :class="{ 'item-logined': item.isLogin }" v-for="item in canUseCompanyList" :key="item.operatorId" @click="onSelectCompany(item)">
        <img :src="item.icon" alt="" class="operatore-icon" />
        <div class="item-info">
          <div class="company-name">
            <span class="company-name-content" :class="[item.isLogin ? 'content-flex' : 'content-margin']"
              >{{ item.companyName }}
              <img class="new-icon" :src="iconNew" v-if="!item.isBindMobile && !item.isLogin" />
            </span>
          </div>
          <div class="mobile">{{ userMobile }}</div>
        </div>
        <div class="right-layout">
          <div class="logined-tag" v-if="item.isLogin">{{ loginText }}</div>
          <div class="btn-entry" v-else>进入</div>
        </div>
      </div>
    </div>
    <div class="close-company" v-if="disableCompanyList.length > 0">
      <div class="tips">当前不可用账户</div>
      <div class="company-list">
        <div class="item" v-for="item in disableCompanyList" :key="item.operatorId" @click="onSelectCompany(item)">
          <img :src="item.icon" alt="" class="operatore-icon" />
          <div class="item-info">
            <div class="company-name">
              <span class="company-name-content">{{ item.companyName }}</span>
            </div>
            <div class="mobile">{{ userMobile }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="new-company-container ka-safe-area-bottom">
      <div class="shadow"></div>
      <div class="new-company" @click="onLoginNewCompany">
        <div class="button">登录新企业</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Indicator, MessageBox } from 'mint-ui'
import { isEmpty } from '@yxcx/util'
import LoginService from '@svc/login'
import WechatService from '@svc/wechat'
import Account from '@lib/account'
import cookie from '@lib/cookie'
import CookieConstant from '@con/index'
import { app } from '@util/platform'
import { getOpRedirectUri, toBindScoreTicketUnified } from '@util/navigation'
import setDocumentTitle from '@util/document-title'
import { navigateBackMiniProgram } from './use/useLoginOpen'
import userManager from '@util/userManager'

import defaultCompanyIcon from '@img/main-logo.png'

// 前端兑换页状态 0:关闭   1:开启
const CompanyStatus = {
  OPEN: 1,
  CLOSE: 0,
}

export default {
  data() {
    return {
      iconNew: require('@img/company-new.png'),
      companyList: [],
      CLOSE: CompanyStatus.CLOSE,
      topTips: '当前手机号以下账户',
      canUseCompanyList: [],
      disableCompanyList: [],
      // 手机号码是否已绑定微信
      isBindWechat: false,
    }
  },
  computed: {
    loginText() {
      return this.isFromSetting ? '当前登录' : '最近登录'
    },
    /* 跳转是否来源于设置页面 */
    isFromSetting() {
      const redirectUri = this.$route.query.redirectUri
      return redirectUri && /setting/.test(redirectUri)
    },
    userMobile() {
      const mobile = userManager.getMobile() || ''
      return `${mobile.slice(0, 3)}****${mobile.slice(7, 11)}`
    },
  },
  mounted() {
    setDocumentTitle('选择企业')
    this.setup()
  },
  methods: {
    async setup() {
      Indicator.open()
      await Promise.all([this.fetchUserCompanyList(), this.fetchWechatBindMobile()])
      Indicator.close()
    },
    getMallCodeInCookie() {
      return cookie(CookieConstant.COOKIE_KAOP_OPERATION_CODE)
    },
    async fetchUserCompanyList() {
      try {
        const result = await LoginService.getOpBindingCompanyList()
        this.handleCompanyList(result.list || [])
      } catch (err) {
        console.error(err)
      }
    },
    handleCompanyList(list) {
      this.companyList = list
      list.forEach((v) => {
        v.icon = v.icon || defaultCompanyIcon
        if (v.status === 1) {
          this.canUseCompanyList.push(v)
        } else {
          this.disableCompanyList.push(v)
        }
      })
    },
    async fetchWechatBindMobile() {
      try {
        const res = await WechatService.queryWechatBindMobile({ mobile: userManager.getMobile() })
        this.isBindWechat = !isEmpty(res?.openId)
      } catch (err) {
        console.error(err)
        this.isBindWechat = false
      }
    },
    onSelectCompany(item) {
      if (item.status === CompanyStatus.CLOSE) {
        Toast({
          message: '该企业员工已被禁止登录，如有疑问，请联系公司相关人员~',
          position: 'bottom',
          duration: 3000,
        })
        return false
      }

      // 从设置页进入，如果点击当前登录企业，不作响应
      if (item.isLogin && this.isFromSetting) {
        return false
      }
      this.loginWithBindCompany(item)
    },
    async loginWithBindCompany(item) {
      try {
        Indicator.open()
        const { operatorId, mallCode } = item
        // 切换企业，需要重新拉取企业配置信息
        const result = await LoginService.insideLogin({ operatorId })
        if (app.isMiniProgram()) {
          navigateBackMiniProgram(result)
        } else {
          // 更新登录态
          Account.setLoginSuccessData(result)
          // 跳转
          this.toRedirect(mallCode)
        }
      } catch (err) {
        console.error(err)
        Toast({
          message: err.msg,
          position: 'bottom',
          duration: 3000,
        })
      } finally {
        Indicator.close()
      }
    },
    toRedirect(mallCode) {
      const redirectUri = getOpRedirectUri({
        cb: this.$route.query.redirectUri,
        mallCode,
      })
      window.location.href = redirectUri
    },
    onLoginNewCompany() {
      toBindScoreTicketUnified()
    },
    async onUnbind() {
      const boxRes = await MessageBox({
        title: '',
        message: '是否解除绑定？',
        confirmButtonText: '是',
        cancelButtonText: '否',
        showCancelButton: true,
      })
      if (boxRes === 'confirm') {
        await WechatService.cancelWechatBindMobile({ mobile: userManager.getMobile() })
        Toast('解除成功')
        this.isBindWechat = false
      }
    },
    fetch,
  },
}
</script>

<style lang="less" scoped>
.select-company {
  min-height: 100vh;
  padding: 16px 0 100px;
  background-color: #f4f4f4;

  .tips {
    color: #323233;
    font-size: 16px;
    padding: 0 12px;
    font-weight: bold;
  }

  .bint-wechat {
    display: flex;
    align-items: center;
    margin: 5px 0 0 12px;

    .binded-mobile {
      font-size: 14px;
      color: #323233;
      line-height: 22px;
    }

    .bind-tips {
      padding: 4px 8px;
      background: #e2f8ed;
      border-radius: 12px;
      font-size: 12px;
      color: #016431;
      line-height: 16px;
      margin-left: 4px;
    }
  }

  .company-list {
    padding: 0 12px;
    overflow: scroll;
    &-margin {
      margin-top: 16px;
    }
  }
  .item-logined {
    border: 1px solid #ff3500;
  }
  .item {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 16px;
    background-color: #fff;
    margin-bottom: 10px;
    border-radius: 8px;
    .operatore-icon {
      height: 49px;
      width: 49px;
      border-radius: 8px;
    }
    .item-info {
      flex: 1;
      margin-left: 12px;
      color: #323233;
      font-size: 14px;
      margin-top: 1px;
    }
    .company-name {
      margin-bottom: 8px;
      line-height: 21px;
      display: inline-flex;
      justify-content: space-between;
      align-items: center;
    }
    .mobile {
      color: #969799;
      font-size: 13px;
      line-height: 21px;
    }

    .right-layout {
      flex-shrink: 0;

      .logined-tag,
      .btn-entry {
        width: 74px;
        height: 32px;
        border-radius: 16px;
        line-height: 32px;
        text-align: center;
        font-size: 14px;
      }

      .logined-tag {
        background: #fff5f2;
        color: #ff3500;
      }

      .btn-entry {
        background: #ff3500;
        color: #ffffff;
      }
    }
  }

  .conpany-name {
    flex: 1;
    color: #2e2f30;
    font-size: 15px;
    margin-right: 20px;
  }
  .company-name-content {
    display: inline-block;
    position: relative;
    font-weight: bold;
  }
  .content-flex {
    flex: 1;
  }
  .content-margin {
    margin-right: 16px;
  }
  .new-icon {
    width: 37px;
    height: 21px;
    position: absolute;
    top: -10px;
    right: -40px;
    z-index: 1;
  }
  .close {
    color: #d2d6dc;
  }

  .close-tag {
    color: #bdc0c5;
    font-size: 12px;
    background-color: #f4f4f4;
    border-radius: 2px;
    padding: 2px 5px;
  }

  .new-title {
    color: #797d82;
    font-size: 13px;
    margin: 40px 0 15px 15px;
  }

  .right-arrow {
    width: 7px;
    height: 12px;
  }

  .el-margin {
    margin-left: 5px;
  }

  .new-company-container {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;

    .shadow {
      position: absolute;
      top: -22px;
      left: 0;
      width: 100%;
      height: 22px;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.12) 100%);
    }

    .new-company {
      padding: 8px 12px;
    }

    .button {
      width: 100%;
      height: 40px;
      line-height: 40px;
      border-radius: 22px;
      background-color: #ff3500;
      color: #ffffff;
      text-align: center;
      font-weight: bold;
      font-size: 16px;
    }
  }

  .close-company {
    margin-top: -10px;
    .company-name {
      color: #969799;
    }
  }
}
</style>
